import { useCallback } from '@frontend/react';
import { Icon, showToast, XStack } from '@frontend/web-react';

type TaskChatMessageFooterProps = {
  copyContent: string;
};
export const TaskChatMessageFooter = ({ copyContent }: TaskChatMessageFooterProps) => {
  const copyBodyToClipboard = useCallback(() => {
    navigator.clipboard.writeText(copyContent);
    showToast({
      title: 'Message copied',
      variant: 'success',
    });
  }, [copyContent]);

  return (
    <XStack className="-ml-xs opacity-0 transition-opacity group-hover:opacity-100">
      <Icon className="cursor-pointer" color="tertiary" name="IconCopy" onClick={copyBodyToClipboard} size="sm" />
    </XStack>
  );
};
